import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import StoreCard from "../components/storeCard";
import ServiceCard from "../components/serviceCard";
import { services, servicesArray } from "../../../constants/customer";
import TopImageSection from "../components/topImageSection";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearOrderDetails,
  setOrderFlow,
  setSelectedService,
  setSelectedShop,
} from "../../../Redux/Slices/customerSlice";
import CustomPopupForm from "../../../component/customPopupModel";
import { useSnackbar } from "../../../component/SnackbarContext";
import axiosInstance from "../../../configuration/request";
import { serviceFormat } from "../../../constants/bussiness";

const CustomerHome = () => {
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [shop, setShop] = useState();
  const [favorite, setFavorite] = useState([]);
  const [offeredLaundry, setOfferedLaundry] = useState([]);
  const [offeredServices, setOfferedService] = useState(servicesArray);
  const [selectedType, setSelectedType] = useState("");

  const showSnackbar = useSnackbar();
  const handleClose = () => setOpen(false);

  useEffect(() => {
    dispatch(clearOrderDetails());
    fetchFavorite();
    fetchOfferedLaundry();
  }, [userId]); // Added userId as dependency for safety

  const fetchFavorite = () => {
    if (!userId) return;
    axiosInstance
      .get(`/customer/store/favouriteStores/${userId}?page=1&limit=6`)
      .then((res) => {
        const rawData = res?.data?.data;
        const mappedShops = rawData?.map((shop) => {
          const today = new Date().toLocaleDateString("en-US", { weekday: "long" });
          const todayHours = shop?.store_hours?.[today] || "null";
          const shopImageDoc = shop?.uploadDoc?.find((doc) => doc.name === "shop_image");
          const image = shopImageDoc ? shopImageDoc.fileUrl : null;
          const services = (shop?.services || []).map((service) => serviceFormat(service.serviceType));
          return {
            id: shop?.id,
            title: shop?.storeName,
            time: todayHours,
            status: shop?.storeStatus ? "Open" : "Closed",
            services: services,
            rating: shop?.average_rating,
            image,
            isFavorite: true,
            preferred: shop?.preferred,
          };
        });
        setFavorite(mappedShops);
      })
      .catch((err) => console.error("Fav Fetch Error:", err));
  };

  const fetchOfferedLaundry = () => {
    if (!userId) return;
    axiosInstance
      .get(`/customer/store/offered-laundary/${userId}?page=1&limit=6`)
      .then((res) => {
        const rawData = res?.data?.data;
        const mappedShops = rawData?.map((shop) => {
          const today = new Date().toLocaleDateString("en-US", { weekday: "long" });
          const todayHours = shop?.store_hours?.[today] || "null";
          const shopImageDoc = shop?.uploadDoc?.find((doc) => doc.name === "shop_image");
          const image = shopImageDoc ? shopImageDoc.fileUrl : null;
          const services = (shop?.services || []).map((service) => serviceFormat(service.serviceType));
          return {
            id: shop?.id,
            title: shop?.storeName,
            time: todayHours,
            status: shop?.storeStatus ? "Open" : "Closed",
            services: services,
            rating: shop?.average_rating,
            image,
            isFavorite: shop?.isFavourite,
            preferred: shop?.preferred,
          };
        });
        setOfferedLaundry(mappedShops);
      })
      .catch((err) => console.error("Offered Fetch Error:", err));
  };

  // Function to refresh all data when a favorite is toggled
  const handleRefreshData = () => {
    fetchFavorite();
    fetchOfferedLaundry();
  };

  const handleServiceSelect = (service) => {
    dispatch(setSelectedService(service));
    dispatch(setOrderFlow("service"));
    navigate("/pickup-details");
  };

  const handleOrder = (service) => {
    dispatch(setSelectedService(service));
    dispatch(setSelectedShop(shop));
    dispatch(setOrderFlow("shop"));
    navigate("/pickup-details");
  };

  const handleSelectService = (service) => {
    setOpen(false);
    if (selectedType === "shop") {
      handleOrder(service);
    } else {
      handleServiceSelect(service);
    }
  };

  return (
    <div className="pb-4">
      <TopImageSection
        title="Cleaning Services"
        text=" Laundry day is over. With Tydii, a few taps connects you to trusted local laundromats, dry cleaners, and tailors for pickup, professional care, and delivery right to your door."
        page="home"
        shedulePickup={() => {
          setOpen(true);
          setOfferedService(servicesArray);
        }}
      />

      <div className="text-center my-8">
        <h3 className="text-base xs:text-xl md:text-2xl font-medium text-[var(--text-pr)]">
          Tell us how we can help today
        </h3>
        <div className="flex justify-center gap-6 md:gap-12 mt-6">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              service={service}
              onServiceSelect={handleServiceSelect}
            />
          ))}
        </div>
      </div>

      {/* Favourite Laundry */}
      {favorite.length > 0 && (
        <div className="px-2 xs:px-4 md:px-10">
          <div className="flex justify-between items-center">
            <h4 className="text-base sm:text-lg md:text-xl font-semibold text-[var(--text-pr)]">
              Favourite <span className="text-[var(--highlight-text)]">Laundry</span>
            </h4>
            {favorite.length >= 6 && (
              <a href="/favourite" className="flex font-[500] hover:text-[var(--highlight-text)] text-sm md:text-base">
                View All <span className="text-[var(--highlight-text)] ml-1 mt-1"><IoIosArrowForward /></span>
              </a>
            )}
          </div>

          <div className="hide-scrollbar flex overflow-x-auto gap-6 py-1 md:py-4 scroll-smooth items-stretch h-[310px] md:h-[410px]">
            {favorite?.map((laundry, index) => (
              <div key={index} className="flex-shrink-0 h-full min-w-[250px] max-w-[250px] md:min-w-[300px] md:max-w-[300px]">
                <StoreCard
                  laundry={laundry}
                  index={index}
                  updateFavorit={handleRefreshData} // Pass refresh logic
                  handleOrder={() => {
                    setOfferedService(laundry.services);
                    setShop(laundry);
                    setSelectedType("shop");
                    setOpen(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Offered Laundry */}
      {offeredLaundry.length > 0 && (
        <div className="mx-3 sm:mx-4 md:mx-10 mt-4 md:mt-8 bg-[var(--offered-bg)] px-4 py-6 md:px-8 md:py-8 rounded-[30px]">
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-base sm:text-lg md:text-xl font-semibold text-[var(--white-text)]">
              Offered Laundry
            </h4>
            {offeredLaundry.length >= 6 && (
              <a href="/offered-laundry" className="flex text-sm md:text-base font-[400] text-[var(--white-text)]">
                View All <span className="ml-1 mt-1"><IoIosArrowForward /></span>
              </a>
            )}
          </div>
          <div className="hide-scrollbar flex overflow-x-auto gap-6 py-1 md:py-4 scroll-smooth items-stretch h-[310px] md:h-[410px]">
            {offeredLaundry.map((laundry, index) => (
              <div key={index} className="flex-shrink-0 h-full min-w-[250px] max-w-[250px] md:min-w-[300px] md:max-w-[300px]">
                <StoreCard
                  laundry={laundry}
                  index={index}
                  updateFavorit={handleRefreshData} // Pass refresh logic
                  handleOrder={() => {
                    setOfferedService(laundry.services);
                    setShop(laundry);
                    setSelectedType("shop");
                    setOpen(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType="service-selection"
        onSubmit={handleSelectService}
        dialogDetails={{
          selected_services: offeredServices,
        }}
      />
    </div>
  );
};

export default CustomerHome;
